import { i18n } from '../../i18n';

export class Translations {
  private _t: Function;
  private readonly _initPromise: Promise<void>;
  private _resolveInitPromise: Function;

  constructor() {
    this.init = this.init.bind(this);
    this._initPromise = new Promise<void>((resolve) => {
      this._resolveInitPromise = resolve;
    });
  }

  waitForInit() {
    return this._initPromise;
  }

  init(locale, currentVersion) {
    return i18n({ locale, currentVersion }).then(({ t }) => {
      this._t = t;
      this._resolveInitPromise?.();
    });
  }

  t(key, options = {}) {
    if (!this._t) {
      throw new Error('Translation service was not initialized yet!');
    }
    return this._t(key, options);
  }
}
